import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

export default function ServiceCard({ icon, title, description, link }) {
  return (
    <div className="card p-6 h-full flex flex-col">
      <div className="w-16 h-16 bg-ayurveda-green-light rounded-full flex items-center justify-center mb-4">
        {icon}
      </div>
      
      <h3 className="text-xl font-heading font-bold text-ayurveda-green-dark mb-3">
        {title}
      </h3>
      
      <p className="text-gray-600 mb-4 flex-grow leading-relaxed">
        {description}
      </p>
      
      <Link 
        to={link} 
        className="inline-flex items-center gap-2 text-ayurveda-green hover:text-ayurveda-green-dark font-semibold transition group"
      >
        Learn More
        <ArrowRightIcon className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
      </Link>
    </div>
  );
}
